import CheckBoxLabelHookForm from "components/CheckBoxLabelHookForm";
import TextInputLabelHookForm from "components/TextInputLabelHookForm";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { useRecoilValue } from "recoil";
import { PolicyTermType } from "../../types";
import { editStatePolicyTerm } from "../atoms/atoms";

const PolicyTermInput = (props: {
  setChanges: React.Dispatch<React.SetStateAction<boolean>>;
  data: PolicyTermType | undefined;
  errorMessage?: string | null;
}) => {
  // Props drilled
  const { data, setChanges, errorMessage } = props;

  // Recoil Hook
  const edit = useRecoilValue(editStatePolicyTerm);

  // Form Functions
  const { register } = useFormContext();
  const formMethods = useFormContext();

  // Local Hooks
  const [inputData, setInputData] = useState(data?.polTerm ?? 0);
  const [checkBoxChanges, setCheckBoxChanges] = useState(data?.isActive);

  return (
    <>
      <div className="bg-bgDB">
        <div className="m-2 bg-white box-shadow h-full">
          <div className="grid grid-cols-4 mx-3 pb-2 gap-6 py-2">
            <div className="col-span-2 my-1">
              <TextInputLabelHookForm
                name="polTerm"
                label="Policy Term Duration"
                type="number"
                required={true}
                onChange={(e) => {
                  const value = e.target.value.trim();
                  setInputData(value);
                  if (
                    value.length === 0 ||
                    (value === data?.polTerm &&
                      checkBoxChanges === data?.isActive)
                  ) {
                    setChanges(false);
                  } else {
                    setChanges(true);
                  }
                }}
                className={
                  formMethods.formState.errors.polTerm &&
                  formMethods.formState.errors.polTerm.message &&
                  "border-2 border-red-500 col-span-2 "
                }
                register={formMethods.register("polTerm", {
                  required: {
                    value: true,
                    message: "Required Field",
                  },
                })}
                maxLength={255}
              />

              {errorMessage && (
                <p className="text-xs text-red-500 mt-2">{errorMessage}</p>
              )}
            </div>

            {edit && (
              <div className="col-span-2 my-1">
                <CheckBoxLabelHookForm
                  name="isActive"
                  type="checkbox"
                  label={
                    checkBoxChanges
                      ? "Uncheck to Deactivate"
                      : "Check to Activate"
                  }
                  validation={{
                    required: {
                      value: false,
                      message: "Required Field",
                    },
                  }}
                  className={
                    formMethods.formState.errors.isActive &&
                    formMethods.formState.errors.isActive.message &&
                    "border-2 border-red-500 col-span-2 "
                  }
                  onClick={(e) => {
                    setCheckBoxChanges(e.target.checked);
                    if (
                      e.target.checked === data?.isActive &&
                      inputData === data?.polTerm
                    ) {
                      setChanges(false);
                    } else {
                      setChanges(true);
                    }
                  }}
                  register={register}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PolicyTermInput;
